<mat-icon *ngIf="icon" [svgIcon]="icon" class="square-icon alert-icon"></mat-icon>

<div class="text-wrap">
  <div class="text"><ng-content></ng-content></div>
</div>
